import { useEffect, useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { Confirm } from "./Requests";

export default function Messages() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/admin/messages").then((r) => setItems(Array.isArray(r.data) ? r.data : [])).catch(() => toast.error("No se pudieron cargar los mensajes"));
  useEffect(() => { load(); }, []);
  return (
    <div className="space-y-3" data-testid="messages-panel">
      {!items.length && <p className="py-14 text-center text-[var(--muted)]">No hay mensajes.</p>}
      {items.map((m) => (
        <div key={m.id} className="rounded-sm border border-[var(--line)] bg-white p-5" data-testid="message-card">
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div><p className="font-medium">{m.name}</p><p className="text-sm text-[var(--muted)]"><a href={`mailto:${m.email}`} className="underline">{m.email}</a>{m.phone ? ` · ${m.phone}` : ""} · {m.lang?.toUpperCase()} · {new Date(m.created_at).toLocaleString("es-ES")}</p></div>
            <Confirm title="¿Eliminar mensaje?" text="Esta acción no se puede deshacer." onOk={() => api.delete(`/admin/messages/${m.id}`).then(load)} trigger={<button className="rounded-full border border-[var(--line)] p-2 hover:text-[#B42318]" aria-label="Eliminar" data-testid="message-delete"><Trash2 className="h-4 w-4" /></button>} />
          </div>
          <p className="mt-3 whitespace-pre-wrap text-sm">{m.message}</p>
        </div>
      ))}
    </div>
  );
}
